import { Injectable } from '@angular/core';
import { IAdapter } from 'src/app/models';
import { MouldLogEntry } from 'src/app/models/domain';
import { EntryGetContract } from 'src/generated-clients/mould_log';

@Injectable({
  providedIn: 'root',
})
export class MouldLogEntryAdapter implements IAdapter<MouldLogEntry, EntryGetContract> {
  public adaptToDomain(item: EntryGetContract): MouldLogEntry {
    return new MouldLogEntry(
      item.id ?? '',
      (item.longDescription?.length ?? 0) > 0,
      item.shortDescription ?? '',
      item.code?.description ?? '',
      item.createdBy?.shortName ?? '',
      item.code?.code ?? '',
      item.longDescription ?? '',
      item.createdDate !== undefined ? new Date(item.createdDate) : undefined
    );
  }
}
